import Localization from "../../../../localization";
import ConfigurationForm from "./configurationForm";
import { Modal } from "../../../../components";
import useViewModel from "../../viewModel";
import { Enums } from "../../../../utils";
import React, { useRef } from "react";

const ModifyWebhook = ({}, ref) => {
  const editFormRef = useRef({});
  const { webhooks, updateWebhooks, smhiSupportedDevice, testWebhookSignal } =
    useViewModel();

  const onWebhookUpdate = async (data) => {
    try {
      await editFormRef.current.validateFields();
      const fieldsValue = {
        ...editFormRef.current.getFieldsValue(),
        enabled: data.enabled,
      };
      if (fieldsValue.method === Enums.webhookMethods.get)
        fieldsValue.body = "";
      await updateWebhooks(
        !data.signal
          ? [fieldsValue]
          : webhooks.map((_) =>
              _.signal === data.signal ? { ..._, ...fieldsValue } : _
            )
      );
      ref.current.close();
    } catch (error) {}
  };

  return (
    <Modal
      ref={ref}
      title={(_) =>
        !smhiSupportedDevice
          ? Localization.general.non_supported_smhi
          : `${
              !_.url
                ? Localization.general.new_webhook
                : Localization.general.edit_webhook
            } - ${Enums.details(_.signal)?.name ?? ""}`
      }
      child={(webhook) => (
        <ConfigurationForm
          webhook={webhook}
          ref={editFormRef}
          onSave={() => onWebhookUpdate(webhook)}
          close={() => ref.current.close()}
          onTest={async () => {
            await editFormRef.current.validateFields();
            return await testWebhookSignal(
              editFormRef.current.getFieldsValue()
            );
          }}
        />
      )}
    />
  );
};

export default React.forwardRef(ModifyWebhook);
